import { useState } from 'react';
import { Switch } from '@headlessui/react';

function MarketplaceManagement() {
  const [activeTab, setActiveTab] = useState('settings');
  const [marketplaces, setMarketplaces] = useState({
    amazonUAE: false,
    noonUAE: false,
    carrefourUAE: false,
    luluGroup: false
  });

  return (
    <div>
      <h1 className="text-4xl font-bold mb-8">Marketplace Management</h1>
      
      <div className="mb-8">
        <nav className="flex space-x-4">
          <button
            className={`px-4 py-2 text-lg rounded-full ${
              activeTab === 'settings'
                ? 'bg-black text-white'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('settings')}
          >
            Publishing Marketplaces
          </button>
          <button
            className={`px-4 py-2 text-lg rounded-full ${
              activeTab === 'connections'
                ? 'bg-black text-white'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('connections')}
          >
            Pulling Marketplaces
          </button>
        </nav>
      </div>

      {activeTab === 'settings' && (
        <>
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-3xl font-bold">Publishing Settings</h2>
            <div className="flex items-center space-x-2">
              <span className="text-gray-500">0 Active</span>
            </div>
          </div>

          <div className="flex space-x-4 mb-8">
            <button className="px-4 py-2 bg-black text-white rounded-full">UAE</button>
            <button className="px-4 py-2 text-gray-500 hover:text-gray-700 rounded-full">
              Saudi Arabia
            </button>
            <button className="px-4 py-2 text-gray-500 hover:text-gray-700 rounded-full">
              Egypt
            </button>
          </div>

          <div className="space-y-4">
            {Object.entries({
              'Amazon UAE': 'amazonUAE',
              'Noon UAE': 'noonUAE',
              'Carrefour UAE': 'carrefourUAE',
              'Lulu Group': 'luluGroup'
            }).map(([label, key]) => (
              <div
                key={key}
                className="bg-white rounded-xl p-6 flex items-center justify-between shadow-sm"
              >
                <div>
                  <h3 className="text-xl font-semibold">{label}</h3>
                  <p className="text-gray-500">Not Connected</p>
                </div>
                <Switch
                  checked={marketplaces[key]}
                  onChange={(checked) =>
                    setMarketplaces((prev) => ({ ...prev, [key]: checked }))
                  }
                  className={`${
                    marketplaces[key] ? 'bg-indigo-600' : 'bg-gray-200'
                  } relative inline-flex h-6 w-11 items-center rounded-full`}
                >
                  <span className="sr-only">Enable {label}</span>
                  <span
                    className={`${
                      marketplaces[key] ? 'translate-x-6' : 'translate-x-1'
                    } inline-block h-4 w-4 transform rounded-full bg-white transition`}
                  />
                </Switch>
              </div>
            ))}
          </div>
        </>
      )}

      {activeTab === 'connections' && (
        <div className="space-y-4">
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <h3 className="text-xl font-semibold mb-4">API Credentials</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  API Key
                </label>
                <input
                  type="password"
                  className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  API Secret
                </label>
                <input
                  type="password"
                  className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                />
              </div>
              <button className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">
                Save Credentials
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MarketplaceManagement;